<template>
  <Popup v-model="error.show" :centered="true">
    <h2 class="pfpopup__title" v-html="error.title"></h2>
    <p class="pfpopup__text" v-if="error.text" v-html="error.text"></p>
    <Btn class="pfpopup__btn" v-if="error.btnText" @click.stop.prevent="$store.commit('setError', { show: false })">{{error.btnText}}</Btn>
  </Popup>
</template>

<script>
import { mapState } from 'vuex'
import Popup from './Popup.vue'
import Btn from './ui/Btn.vue'

export default {
  components: { Popup, Btn },
  computed: {
    ...mapState(['error'])
  }
}
</script>

<style lang="sass">

</style>